module.exports = __webpack_public_path__ + "img/tb-2.b401bd9f.png";